import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the page to the element matching location.hash whenever the
 * URL changes. Needed because React Router v6 doesn't auto-scroll to
 * hash fragments on navigation (e.g. clicking a link to "/#contact"
 * from another page).
 */
const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait a tick so the target section is actually rendered.
      const id = hash.replace('#', '');
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };
      // Double rAF to ensure DOM is painted
      requestAnimationFrame(() => requestAnimationFrame(scroll));
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToHash;
